import React from 'react'
import { TextField } from 'mui-rff'
import { Typography, Button, Box } from '@mui/material'
import { Form } from 'react-final-form'
import { Link, useNavigate } from 'react-router-dom'
import { useLogin } from '../../api/user'
import { useSnackbar } from 'notistack'

const LoginForm = () => {
  const loginApi = useLogin()
  // const { refetch } = useMe()
  const navigate = useNavigate()

  const { enqueueSnackbar } = useSnackbar()
  const onSubmit = async (values) => {
    const res = await loginApi.mutateAsync(values).catch((e) => {
      enqueueSnackbar('Failed to login', {
        variant: 'error',
      })
    })
    if (res.status === 200) {
      enqueueSnackbar('Login Success', {
        variant: 'success',
      })
      //await refetch()

      navigate('/')
    }
  }

  const formFields = [
    {
      size: 12,
      field: <TextField type='email' label='Email' name='email' margin='none' required={true} />,
    },
    {
      size: 12,
      field: (
        <TextField type='password' label='Password' name='password' margin='none' required={true} />
      ),
    },
  ]
  return (
    <Box
      boxSizing='border-box'
      m='auto'
      width='100%'
      maxWidth={500}
      mt={10}
      mb={10}
      border='1px solid #808080'
      p={{ xs: '30px', md: '65px' }}
      borderRadius={4}
      bgcolor='#fff'
    >
      <Box mb={3}>
        <Typography variant='h5'>Login</Typography>
      </Box>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              minHeight={200}
            >
              {formFields.map((item, idx) => (
                <Box xs={item.size} key={idx} display='flex' flexDirection='column'>
                  {item.field}
                </Box>
              ))}

              <Button
                variant='contained'
                type='submit'
                disabled={submitting}
                style={{ backgroundColor: 'black', color: 'white' }}
              >
                Submit
              </Button>
            </Box>
          </form>
        )}
      />
      <Box mt={2}>
        <Link to='/forgot-password' style={{ color: '#000' }}>
          <Button style={{ color: '#000' }}>Forgot Password?</Button>
        </Link>
      </Box>
    </Box>
  )
}

export default LoginForm
